<!--  -->
<template>
<div>
     <div class="layout-content" style="background: transparent;">
      <div  v-if="list.length">
        <Table ref="selection" :columns="columns" :data="list">
          <template slot-scope="{ row }" slot="sourceName">{{row.sourceName}}</template>
          <template slot-scope="{ row }" slot="sourceIdCount">{{row.sourceIdCount}}</template>
        </Table>
        <div class="my-page" v-if="totalCount > pageSize" style="margin: 20px;text-align: center;">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
        <!--创建个Echars-->
        <!-- <div class="charts">
          <div ref="chart" :style="{width: '1000px', height: '400px'}"></div>
        </div> -->
        
      </div>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
data() {
return {
    columns: [
        {
          title: "展商名称",
          slot: "sourceName",
          align: "center",
          //width: 240
        },
        {
          title: "数量",
          slot: "sourceIdCount",
          align: "center",
          //width: 240
        }
      ],
      list: [],
      pageSize:10,
      pageIndex:1,
      totalCount:"",
      arr1:[]
}
},
//生命周期 - 创建完成（访问当前this实例）
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
     
      getCallingCardStatistics: "hostCommonModule/getCallingCardStatistics"
    }),
    async init() {
    let opt={
   
    "pageSize": this.pageSize,
    "pageIndex": this.pageIndex,
    "sorts": [{ "propertyName": "sourceIdCount", "ascending": false }],
    "Wheres": {
        "Type": 1, 
        "Wheres": {
            "Label": "sourceType",
            "Value": "1"
        }
    }
    }
      let data=await this.getCallingCardStatistics(opt)
      if(data&&data.items&&data.items.length>0){
          this.list=data.items
      }
      let arr=[]
      let arr1=[]
      this.list.forEach((e)=>{
        arr.push(e.sourceName)
        this.arr1.push(e.sourceIdCount)
      })
    //   this.$nextTick(() => {
    //    console.log(arr,'123');
    //     let myChart = this.$echarts.init(this.$refs.chart);
        
    //     // 绘制图表
    //     myChart.setOption({
    //         title: { text: '前十展商洽谈数量' },
    //         tooltip: {},
    //         grid:{
    //           y2:180
    //         },
    //         xAxis: {
    //             data: arr,
    //             axisLabel:{
    //               interval:0,//横轴信息全部显示
    //               rotate:-30,//-30度角倾斜显示
    //             }
    //         },
            
    //         yAxis: {
    //           type:'value',
    //           min:0,
    //           max:(value=>{
    //             return value.max+0.5*value.max
    //           })
    //         },
    //         series: [{
    //             name: '销量',
    //             type: 'bar',
    //             data: this.arr1
    //         }]
    //     });
    // });
    },

    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
  }

}
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
  .charts{
    display: flex;
    justify-content: center;
    background: #fff;
    padding-top: 30px;
  }
</style>